import { PrivacyComponent } from './pages/privacy/privacy.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteGuardService } from './route-guard.service'
import { LoginComponent } from './pages/login/login.component'
import { MatSnackBarModule } from '@angular/material';
import { NotificacionesComponent } from './components/navbar/notificaciones/notificaciones.component'
const routes: Routes = [
	{
	    path: '',
	    redirectTo: 'login',
	    pathMatch: 'full'
	},
	{
	    path: 'alertas',
	    loadChildren: './alertas/alertas.module#AlertasModule',
	    canActivate:[RouteGuardService]
	},
	{
	    path: 'dashboard',
	    loadChildren: './dashboard/dashboard.module#DashboardModule',
	    canActivate:[RouteGuardService]
	},
	{
	    path: 'analisis',
	    loadChildren: './analisis/analisis.module#AnalisisModule',
	    canActivate:[RouteGuardService]
	},
	{
	    path: 'comportamiento',
	    loadChildren: './comportamiento/comportamiento.module#ComportamientoModule',
	    canActivate:[RouteGuardService]
	},
	{
	    path: 'dispositivos',
	    loadChildren: './dispositivos/dispositivos.module#DispositivosModule',
	    canActivate:[RouteGuardService]
	},{
	    path: 'mantenimientos',
	    loadChildren: './mantenimientos/mantenimientos.module#MantenimientosModule',
	    canActivate:[RouteGuardService]
	},{
	    path: 'reportes',
	    loadChildren: './reportes/reportes.module#ReportesModule',
	    canActivate:[RouteGuardService]
	},{
	    path: 'feedback',
	    loadChildren: './feedback/feedback.module#FeedbackModule',
	    canActivate:[RouteGuardService]
	},
	{
	    path: 'login',
	    component: LoginComponent
	},
	{
	    path: 'privacy',
	    component: PrivacyComponent
	},
	{
	    path: 'notificaciones',
	    component: NotificacionesComponent,
	    // canActivate:[RouteGuardService]
	},{
	    path: 'admin-dashboard',
	    loadChildren: './admin-dashboard/admin-dashboard.module#AdminDashboardModule',
	    canActivate:[RouteGuardService]
	},{
	    path: 'sitios',
	    loadChildren: './sitios/sitios.module#SitiosModule',
	    canActivate:[RouteGuardService]
	},{
		path: 'users',
		loadChildren: './users/users.module#UsersModule',
		canActivate:[RouteGuardService]
	},{
		path: 'catalogos',
		loadChildren: './catalogos/catalogos.module#CatalogosModule',
		canActivate:[RouteGuardService]
	},{
	    path: 'proveedores',
	    loadChildren: './proveedores/proveedores.module#ProveedoresModule'
	},
	{
		path: 'refacciones',
		loadChildren: './refacciones/refacciones.module#RefaccionesModule',
		canActivate:[RouteGuardService]
	},
	{
		path: 'consultas',
		loadChildren: './consultas/consultas.module#ConsultasModule',
		canActivate:[RouteGuardService]
	},
	{
		path: 'administracion',
		// loadChildren: () => import('./refacciones/administracion/administracion.module').then(m => m.AdministracionModule),
		loadChildren: './refacciones/administracion/administracion.module#AdministracionModule',
		canActivate:[RouteGuardService]
	},
	{
		path: 'forecast',
		loadChildren: './forecast/forecast.module#ForecastModule',
		canActivate:[RouteGuardService]
	}

];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true}),MatSnackBarModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
